import {
    SET_LOADING,
    SET_PROJECTS,
    SET_SEARCH_VALUE,
    SET_TENANTS,
    ADD_TENANT,
    ADD_TENANT_APP,
    UPDATE_TENANT,
    UPDATE_TENANT_APP,
    DELETE_TENANT_APP,
    SET_SELECTED_TENANT_ID,
    SET_SELECTED_MASTER_PROJECT_ID,
    SET_NOTIFICATION_MESSAGE,
    SET_NOTIFICATION_TYPE,
    TOGGLE_SHOW_INVITE_USER_DIALOG,
    TOGGLE_SHOW_EDIT_TENANT_DIALOG,
    TOGGLE_SHOW_ADD_APP_DIALOG,
    TOGGLE_SHOW_DELETE_TENANT_APP_DIALOG,
    TOGGLE_SHOW_NOTIFICATION,
} from "./TenantEvents";

export const initialTenantState = {
    tenants: [],
    loading: true,
    projects: [],
    searchValue: "",
    showInviteUserDialog: false,
    showEditTenantDialog: false,
    showAddTenantAppDialog: false,
    showDeleteTenantAppDialog: false,
    noticationType: "error",
    showNotification: false,
    notificationMessage: "",
    selectedTenantId: null,
    selectedMasterProjectId: null,
};
export const TenantReducer = (state, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case SET_SEARCH_VALUE:
            return {
                ...state,
                searchValue: action.payload,
            };
        case TOGGLE_SHOW_INVITE_USER_DIALOG:
            return {
                ...state,
                showInviteUserDialog: !state.showInviteUserDialog,
            };
        case TOGGLE_SHOW_EDIT_TENANT_DIALOG:
            return {
                ...state,
                showEditTenantDialog: !state.showEditTenantDialog,
            };
        case TOGGLE_SHOW_ADD_APP_DIALOG:
            return {
                ...state,
                showAddTenantAppDialog: !state.showAddTenantAppDialog,
            };
        case TOGGLE_SHOW_DELETE_TENANT_APP_DIALOG:
            return {
                ...state,
                showDeleteTenantAppDialog: !state.showDeleteTenantAppDialog,
            };
        case TOGGLE_SHOW_NOTIFICATION:
            return {
                ...state,
                showNotification: !state.showNotification,
            };
        case SET_TENANTS:
            return {
                ...state,
                tenants: action.payload,
            };
        case SET_PROJECTS:
            return {
                ...state,
                projects: action.payload,
            };
        case ADD_TENANT:
            return {
                ...state,
                tenants: [
                    ...state.tenants,
                    action.payload
                ]
            };
        case ADD_TENANT_APP:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.id) {
                        return {
                            ...tenant,
                            masterProjects: [
                                ...tenant.masterProjects,
                                action.payload.data
                            ]
                        }
                    }
                    return tenant;
                })
            };
        case UPDATE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.id) {
                        return {
                            ...tenant,
                            ...action.payload.data
                        }
                    }
                    return tenant;
                })
            };
        case UPDATE_TENANT_APP:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.id) {
                        return {
                            ...tenant,
                            masterProjects: tenant.masterProjects.map(masterProject => {
                                if (masterProject.masterProjectId === action.payload.masterProjectId) {
                                    return {
                                        ...masterProject,
                                        ...action.payload.data
                                    }
                                }
                                return masterProject;
                            })
                        }
                    }
                    return tenant;
                })
            };
        case DELETE_TENANT_APP:
            return {
                ...state,
                tenants: state.tenants.map(tenant => {
                    if (tenant._id === action.payload.id) {
                        return {
                            ...tenant,
                            masterProjects: tenant.masterProjects.filter(masterProject => masterProject.masterProjectId !== action.payload.masterProjectId)
                        }
                    }
                    return tenant;
                })
            };
        case SET_SELECTED_TENANT_ID:
            return {
                ...state,
                selectedTenantId: action.payload
            };
        case SET_SELECTED_MASTER_PROJECT_ID:
            return {
                ...state,
                selectedMasterProjectId: action.payload
            };
        case SET_NOTIFICATION_MESSAGE:
            return {
                ...state,
                notificationMessage: action.payload
            };
        case SET_NOTIFICATION_TYPE:
            return {
                ...state,
                noticationType: action.payload
            };
        default:
            return state;
    }
}
